import axios from "axios";
import ConstantData from "./Constant";
import { triggerLogOut } from "./utils";
import refStore from "./refStore";

export const handlingCatchError = (props, navigate) => {
    let statusCode =
    props.response && props.response.status
      ? props.response.status
      : props.status;
  
  if (props?.response) {
    if (!props.response.data && !statusCode) {
      console.error("Invalid props or missing response.data");
      return;
    }
  }
  else if (!props?.data && !statusCode) {
    console.error("Invalid props or missing data");
    return;
  }
  const rateLimitTimerRef = refStore.rateLimitTimerRef;
  let message = props.response && props.response?.data ? props?.response?.status === 429 ? ConstantData.RateLimitErrorMessage : props.response?.data || props.response?.data?.message : props.data || "";
  if (message?.message) {
    message = message.message;
  }

  //Need to update code to handle 429 like NASS by Kavya
  if (props?.response?.status === 429) //Blob/Json Type 429 Reponse handling
  {
    props.response.statusText = "You have exceeded your allowed request limit. Please try again later.";
    props.response.data.message = "You have exceeded your allowed request limit. Please try again later.";
  }

  if (statusCode === 500) {
    message = "Oops, something went wrong! Please try again after sometime.";
  }

  if (statusCode === 404 && props.data) {
    message =
      props.data === "account not found" ? "Account not found" : props.data;
  }

  if (statusCode === 400 && props.data) {
    message = props.data;
  }
  let severity =
    ConstantData.severityMap[statusCode] || (statusCode < 200 ? "warning" : "error");

  if (statusCode === 401) {
    localStorage.clear();
    axios.defaults.headers.common["Authorization"] = '';
    navigate("/");
  }
  else if (statusCode === 403) {
    localStorage.clear();
    axios.defaults.headers.common["Authorization"] = '';
    navigate("/");
  }
  else if (statusCode === 400 && message === "Authentication failed") {
    navigate("/invalid-access");
  }
  else if (statusCode === 429) {
    let customMessage = message?.message ? message.message : null;
    window.globalThis.REACT_SNACK_AUTO_HIDE = false;
    window.globalThis.REACT_SNACK_OPEN = true;
    window.globalThis.REACT_SNACK_MESSAGE = customMessage
      ? customMessage
      : message
        ? message
        : props.response.statusText
          ? props.response.statusText
          : props.message;
    window.globalThis.REACT_SNACK_SEVERITY = "warning";
    document.getElementById("enable-error-snack").click();
    if (rateLimitTimerRef.current) {
      clearTimeout(rateLimitTimerRef.current);
    }
    rateLimitTimerRef.current = setTimeout(() => {
      if (window.globalThis.REACT_SNACK_OPEN) {
        window.globalThis.REACT_SNACK_OPEN = false;
        window.globalThis.REACT_SNACK_AUTO_HIDE = true;
        document.getElementById('enable-error-snack')?.click()
      }
    }, 3000);
  }
  else {
    let customMessage = message?.message ? message.message : null;
    window.globalThis.REACT_SNACK_AUTO_HIDE = true;
    window.globalThis.REACT_SNACK_OPEN = true;
    window.globalThis.REACT_SNACK_MESSAGE = customMessage
      ? customMessage
      : message
        ? message
        : props.response.statusText
          ? props.response.statusText
          : props.message;
    window.globalThis.REACT_SNACK_SEVERITY = severity;
    document.getElementById("enable-error-snack").click();
  }
};
